import React from 'react';
import styled from 'libs/styled';
import StockStatusBlock from 'libs/sanity/content/Blocks/StockStatusBlock';

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
`;

const StockStatusModule = () => (
    <ModuleWrapper>
        <StockStatusBlock />
    </ModuleWrapper>
);

export default StockStatusModule;
